import { motion } from "framer-motion";
import { GraduationCap, Award, Users, Sparkles } from "lucide-react";

const ACADEMY_IMG = "https://images.unsplash.com/photo-1560869713-7d0a29430803?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwyfHxoYWlyJTIwc3R5bGlzdCUyMHRyYWluaW5nJTIwYWNhZGVteXxlbnwwfHx8fDE3ODM1OTUwNzh8MA&ixlib=rb-4.1.0&q=85";

const fadeUp = {
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
  transition: { duration: 0.6 },
};

export const AcademySection = ({ courses }) => (
  <section id="academy" className="py-24 lg:py-32 bg-[#FAFAF8]">
    <div className="max-w-7xl mx-auto px-6 lg:px-12 grid lg:grid-cols-2 gap-16 items-center">
      <motion.div {...fadeUp}>
        <p className="text-[#C5A059] uppercase tracking-[0.3em] text-xs font-semibold mb-4">The Academy</p>
        <h2 className="font-serif-brand text-4xl sm:text-5xl text-[#1C1C1C] font-medium tracking-tight mb-6">
          Learn From Working Professionals
        </h2>
        <p className="text-[#5C6A63] font-light leading-relaxed mb-10">
          Our certified academy offers hands-on training inside a live, working salon.
          Graduate with real client experience, a professional portfolio, and placement support.
        </p>
        <div className="space-y-6" data-testid="academy-courses">
          {courses.map((c) => (
            <div key={c.id} className="bg-white border border-[#E5E7E5] rounded-md p-6 shadow-[0_4px_20px_rgba(10,63,47,0.05)]">
              <div className="flex items-baseline justify-between gap-4">
                <h3 className="font-serif-brand text-2xl text-[#0A3F2F] font-semibold">{c.name}</h3>
                <span className="text-[#C5A059] font-bold">₹{c.price.toLocaleString("en-IN")}</span>
              </div>
              <p className="text-[#5C6A63] text-sm mt-2 font-light">{c.description}</p>
            </div>
          ))}
        </div>
      </motion.div>
      <motion.div {...fadeUp} className="relative">
        <img src={ACADEMY_IMG} alt="Academy training session" className="w-full h-[560px] object-cover rounded-md" />
        <div className="absolute -bottom-6 -left-6 bg-[#0A3F2F] text-[#FAFAF8] rounded-md p-6 shadow-lg hidden sm:block">
          <p className="font-serif-brand text-4xl font-semibold text-[#C5A059]">500+</p>
          <p className="text-xs uppercase tracking-wider mt-1">Certified Graduates</p>
        </div>
      </motion.div>
    </div>
  </section>
);

const stats = [
  { icon: Award, label: "Google Rating", value: "4.3★" },
  { icon: Users, label: "Client Reviews", value: "266+" },
  { icon: Sparkles, label: "Serving Since", value: "2014" },
  { icon: GraduationCap, label: "Students Trained", value: "500+" },
];

export const AboutSection = () => (
  <section id="about" className="py-24 lg:py-32 bg-white border-y border-[#E5E7E5]">
    <div className="max-w-7xl mx-auto px-6 lg:px-12">
      <motion.div {...fadeUp} className="max-w-2xl mb-16">
        <p className="text-[#C5A059] uppercase tracking-[0.3em] text-xs font-semibold mb-4">About Us</p>
        <h2 className="font-serif-brand text-4xl sm:text-5xl text-[#1C1C1C] font-medium tracking-tight mb-6">
          A Decade of Green Excellence in Sonipat
        </h2>
        <p className="text-[#5C6A63] font-light leading-relaxed">
          Founded in 2014, GREEN Professionals Salon &amp; Academy at Ashok Nagar, Sonipat blends luxury salon care with
          professional education. We specialise in premium hair transformation, chemical artistry and high-definition
          bridal makeovers — using only high-end products from brands like Bobbi Brown and NARS.
        </p>
      </motion.div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-6" data-testid="about-stats">
        {stats.map((s) => (
          <motion.div key={s.label} {...fadeUp} className="border border-[#E5E7E5] rounded-md p-8">
            <s.icon className="w-6 h-6 text-[#C5A059] mb-4" />
            <p className="font-serif-brand text-4xl text-[#0A3F2F] font-semibold">{s.value}</p>
            <p className="text-[#5C6A63] text-sm mt-1">{s.label}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
